/* ============================================================
   OSZEA — Shop All / Collection (Shopify Online Store 2.0)
   ------------------------------------------------------------
   Works with cards rendered server-side by snippets/oszea-colour-card.liquid.
   - Quick Add posts real variant IDs to /cart/add.js
   - Native Shopify facets (the <form> in the filter drawer) handle
     server-side Filter + Sort via page reload (standard behaviour).
   - The category chips + quick pills are a CLIENT-SIDE convenience that
     hide/show already-rendered cards (no reload).
   No build step. Namespaced, dependency-free.
   ============================================================ */
(function(){
  const $  = (s,c)=>(c||document).querySelector(s);
  const $$ = (s,c)=>[...(c||document).querySelectorAll(s)];

  const root = $('.oszea-collection');
  if(!root) return;
  const cartOpenSel = root.getAttribute('data-cart-open') || '';

  /* ---------- Toast ---------- */
  let toastZone = $('#oszeaToast');
  if(!toastZone){ toastZone = document.createElement('div'); toastZone.id='oszeaToast'; toastZone.className='toast-zone'; document.body.appendChild(toastZone); }
  const CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5L20 6"/></svg>';
  function toast(msg){
    const t=document.createElement('div'); t.className='toast';
    t.innerHTML=`<span class="tk">${CHECK}</span>${msg}`;
    toastZone.appendChild(t); requestAnimationFrame(()=>t.classList.add('show'));
    setTimeout(()=>{ t.classList.remove('show'); setTimeout(()=>t.remove(),400); },2600);
  }

  /* ---------- Reveal (scroll + failsafe, robust in any context) ---------- */
  const revealEls = $$('.reveal', root);
  function revealPass(){ const h=innerHeight||800; for(const el of revealEls){ if(!el.classList.contains('in') && el.getBoundingClientRect().top < h*0.92) el.classList.add('in'); } }
  addEventListener('scroll', revealPass, {passive:true}); addEventListener('resize', revealPass, {passive:true});
  revealPass(); setTimeout(revealPass,120); setTimeout(revealPass,500);
  setTimeout(()=>document.documentElement.classList.add('reveal-settled'),1400);

  /* ---------- Category nav: scroll + active spy ---------- */
  const offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--oszea-header-offset')) || 0;
  $$('.catchip', root).forEach(chip=>chip.addEventListener('click',()=>{
    if(chip.dataset.filterK){ // chip that also filters
      setQuick(chip.dataset.filterK, chip.dataset.filterV, true);
    }
    const id = chip.dataset.target;
    if(id){ const el=document.getElementById(id); if(el){ const y=el.getBoundingClientRect().top+scrollY-(offset+96); scrollTo({top:y,behavior:'smooth'}); } }
  }));
  const groups = $$('.col-section', root);
  function spyPass(){
    let cur=null;
    groups.forEach(g=>{ if(g.getBoundingClientRect().top <= offset+150) cur=g; });
    const name = cur ? cur.getAttribute('data-cat') : (groups[0]&&groups[0].getAttribute('data-cat'));
    $$('.catchip', root).forEach(c=>c.classList.toggle('active', c.dataset.cat===name));
  }
  addEventListener('scroll', spyPass, {passive:true}); spyPass();

  /* ---------- Client-side quick filter (chips/pills) ---------- */
  const qstate = { gender:new Set(), use:new Set() };
  function setQuick(k,v,exclusive){
    if(!qstate[k]) return;
    if(exclusive){ qstate[k].clear(); qstate[k].add(v); }
    else { qstate[k].has(v) ? qstate[k].delete(v) : qstate[k].add(v); }
    applyQuick();
  }
  $$('.qpill', root).forEach(p=>p.addEventListener('click',()=>setQuick(p.dataset.k,p.dataset.v,false)));
  function cardMatch(card){
    if(qstate.gender.size){ const g=card.dataset.gender; if(g!=='Unisex' && !qstate.gender.has(g)) return false; }
    if(qstate.use.size){ const us=(card.dataset.use||'').split('|'); if(!us.some(u=>qstate.use.has(u))) return false; }
    return true;
  }
  function applyQuick(){
    let shown=0;
    groups.forEach(g=>{
      let n=0;
      $$('.ccard', g).forEach(c=>{ const ok=cardMatch(c); c.style.display=ok?'':'none'; if(ok){n++;shown++;} });
      g.classList.toggle('empty', n===0);
      const cnt=$('.cs-count', g); if(cnt) cnt.textContent = n+(n===1?' style':' styles');
    });
    const res=$('#colResult', root); if(res){ const total=$$('.ccard',root).length; res.textContent = shown===total?`${total} colours`:`${shown} of ${total} colours`; }
    const active=qstate.gender.size+qstate.use.size;
    $$('.qpill', root).forEach(p=>p.classList.toggle('active', qstate[p.dataset.k] && qstate[p.dataset.k].has(p.dataset.v)));
    $$('.catchip', root).forEach(c=>{ if(c.dataset.filterK) c.classList.toggle('active', qstate[c.dataset.filterK] && qstate[c.dataset.filterK].has(c.dataset.filterV)); });
    const empty=$('#colEmpty', root); if(empty) empty.classList.toggle('show', shown===0);
    spyPass();
  }
  const clearQuick=$('#clearQuick', root);
  if(clearQuick) clearQuick.addEventListener('click',()=>{ qstate.gender.clear(); qstate.use.clear(); applyQuick(); });

  /* ---------- Filter drawer (native facet form lives inside) ---------- */
  const fdrawer=$('#fdrawer', root);
  if(fdrawer){
    const open=()=>{ fdrawer.classList.add('open'); document.body.style.overflow='hidden'; };
    const close=()=>{ fdrawer.classList.remove('open'); document.body.style.overflow=''; };
    $$('[data-openfilter]', root).forEach(b=>b.addEventListener('click', open));
    $$('[data-closefilter]', fdrawer).forEach(b=>b.addEventListener('click', close));
  }

  /* ---------- Size / pack popover ---------- */
  function closeAllSizes(except){ $$('.ccard-sizes.open', root).forEach(s=>{ if(s!==except) s.classList.remove('open'); }); }
  document.addEventListener('click', e=>{
    if(!root.contains(e.target)){ closeAllSizes(); return; }
    const opener=e.target.closest('.js-openSizes');
    if(opener){ e.preventDefault(); const sizes=$('.ccard-sizes', opener.closest('.ccard')); const isOpen=sizes.classList.contains('open'); closeAllSizes(); if(!isOpen) sizes.classList.add('open'); return; }
    if(e.target.closest('[data-szclose]')){ closeAllSizes(); return; }
    if(!e.target.closest('.ccard-sizes') && !e.target.closest('.js-openSizes')) closeAllSizes();
  });

  /* ---------- Add to cart (real Shopify /cart/add.js) ---------- */
  async function addVariant(id, btn){
    if(!id){ toast('Select a size to continue'); return; }
    if(btn) btn.classList.add('loading');
    try{
      const res = await fetch('/cart/add.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8', 'Accept':'application/json' },
        body: new URLSearchParams({ id: String(id), quantity: '1' })
      });
      if(!res.ok){ const err=await res.json().catch(()=>({})); throw new Error(err.description||'Could not add to cart'); }
      const data = await res.json();
      const item = (data.items && data.items[0]) || data;
      toast((item.product_title || 'Item') + ' added to cart');
      refreshCartCount();
      // let the theme know + try to open its cart drawer
      document.dispatchEvent(new CustomEvent('oszea:cart:added', { detail:{ data } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));   // Dawn-ish
      if(cartOpenSel){ const opener=$(cartOpenSel); if(opener) opener.click(); }
      else { window.location.assign(window.routes?.cart_url || '/cart'); }
    }catch(err){ toast(err.message || 'Sorry — could not add that.'); }
    finally{ if(btn) btn.classList.remove('loading'); closeAllSizes(); }
  }
  async function refreshCartCount(){
    try{ const c=await (await fetch('/cart.js')).json();
      $$('[data-cart-count]').forEach(el=>{ el.textContent=c.item_count; el.classList.toggle('show', c.item_count>0); });
    }catch(e){}
  }

  /* ---------- Native collection count: products expand into colour cards ---------- */
  function updateColourCount(){
    if(!root.classList.contains('oszea-native-collection')) return;
    const count = $$('.oszea-variant-card', root).length;
    const label = count + (count === 1 ? ' colour style' : ' colour styles');
    const desktop = $('#ProductCountDesktop', root);
    const mobile = $('#ProductCount', root);
    if(desktop) desktop.textContent = label;
    if(mobile) mobile.textContent = label;
  }
  updateColourCount();
  const nativeGrid = $('#ProductGridContainer', root);
  if(nativeGrid && 'MutationObserver' in window){
    new MutationObserver(updateColourCount).observe(nativeGrid, { childList:true, subtree:true });
  }
  // size / pack chosen
  document.addEventListener('click', e=>{ const qa=e.target.closest('.js-qa'); if(!qa||!root.contains(qa)) return;
    if(qa.closest('.oszea-variant-card')) return;
    e.preventDefault();
    addVariant(qa.dataset.variantId, qa);
  });
  // direct add (one-size / hats, and any "Quick add" that resolves a default variant)
  document.addEventListener('click', e=>{ const a=e.target.closest('.js-add'); if(!a||!root.contains(a)) return;
    if(a.closest('.oszea-variant-card')) return;
    e.preventDefault();
    addVariant(a.dataset.variantId, a);
  });

  /* ---------- Wishlist (localStorage) ---------- */
  const WK='oszea_wishlist';
  let wish=[]; try{ wish=JSON.parse(localStorage.getItem(WK))||[]; }catch(e){}
  $$('.ccard-fav', root).forEach(f=>{ const id=f.closest('.ccard').dataset.id; if(wish.includes(id)) f.classList.add('on'); });
  document.addEventListener('click', e=>{ const f=e.target.closest('.ccard-fav'); if(!f||!root.contains(f)) return;
    const id=f.closest('.ccard').dataset.id; f.classList.toggle('on');
    if(f.classList.contains('on')){ if(!wish.includes(id)) wish.push(id); toast('Saved to your wishlist'); }
    else { wish=wish.filter(x=>x!==id); toast('Removed from wishlist'); }
    try{ localStorage.setItem(WK, JSON.stringify(wish)); }catch(e){}
  });

  /* ---------- FAQ ---------- */
  $$('.faq-q', root).forEach(q=>q.addEventListener('click',()=>{
    const item=q.closest('.faq-item'); const a=$('.faq-a',item); const open=item.classList.contains('open');
    $$('.faq-item', root).forEach(it=>{ it.classList.remove('open'); $('.faq-a',it).style.maxHeight=null; });
    if(!open){ item.classList.add('open'); a.style.maxHeight=a.scrollHeight+'px'; }
  }));

  // close popovers on Esc
  document.addEventListener('keydown', e=>{ if(e.key==='Escape'){ closeAllSizes(); if(fdrawer) fdrawer.classList.remove('open'); document.body.style.overflow=''; } });

  refreshCartCount();
})();
